import React from 'react'

import { Card } from 'components'
import { LongitudinalScoreChart } from '.'

export const ReportLongitudinalScoreCard = ({ loading, report, ...props }) => (
  <Card {...props} heading='Avaliação longitudinal'>
    <LongitudinalScoreChart
      loading={loading}
      scores={report?.score ? [{ date: new Date(report?.dateCreated), score: report.score }] : []}
    />
  </Card>
)

export default ReportLongitudinalScoreCard
